module.exports = {"unfinishedEvents":"query unfinishedEvents($searchQuery:String){events(filter:{tags:[\"mardeminas\"], start_state: [UNSTARTED, HAPPENING],search_query:$searchQuery}, sort: [{by: STARTS_AT, dir: ASC}]){nodes{id name description starts_at slug external_url share_link photo{small_url}tickets{nodes{batches{nodes{price}}}}address{name}}}}"}


//////////////////
// WEBPACK FOOTER
// ./src/assets/graphql-queries.json
// module id = 938
// module chunks = 0